<div class="d-flex justify-content-center align-items-center min-vh-100 bg-light">
  <div class="container" style="max-width: 400px;">
    
    <app-card title="Reset Password">
      <div class="mb-2 text-center">
        <div  [ngClass]="{'logo': isProd, 'logo-training': !isProd && !isStaging, 'logo-staging': !isProd && isStaging}" ></div>
      </div>
      
      <div class="mb-3">
        <label class="form-label">Email Address</label>
        <input type="email" 
               class="form-control" 
               [(ngModel)]="emailAddress" 
               placeholder="Email Address">
      </div>

      <div class="mb-3">
        <label class="form-label">New Password</label>
        <input type="password" 
               class="form-control" 
               [(ngModel)]="newpassword" 
               placeholder="New Password">
      </div>

      <div class="mb-3">
        <label class="form-label">Retype Password</label>
        <input type="password" 
               class="form-control" 
               [(ngModel)]="retypePassword" 
               placeholder="Retype Password">
      </div>

      <!-- Hidden field for password reset token -->
      <input type="hidden" [(ngModel)]="passwordResetToken">

      <div class="d-flex justify-content-end">
        <button *ngIf="!creatingPassword" 
                type="button" 
                class="btn btn-success" 
                (click)="createNewPassword()">
          Update Password
        </button>

        <button *ngIf="creatingPassword" 
                type="button" 
                class="btn btn-success" 
                disabled>
          <span class="spinner-border spinner-border-sm me-2"></span>
          Updating...
        </button>
      </div>
    </app-card>

  </div>
</div>